export default __webpack_public_path__ + "static/media/photo--lg--org-1.51c41f49.jpg";